import moment, { MomentInput } from 'moment'

export type OptionsType = {
  withWeek: boolean
}

const defaultOptions: OptionsType = {
  withWeek: false,
}

const formatDate: (
  date?: MomentInput,
  options?: Partial<OptionsType>
) => string = (date, options = {}) => {
  if (!date) {
    return ''
  }

  const actualOptions = Object.assign({}, defaultOptions, options)

  if (actualOptions.withWeek) {
    return moment(date).format('LL (ddd)')
  } else {
    return moment(date).format('LL')
  }
}

export default formatDate
